import React from 'react';
import { FaTimes, FaDownload } from 'react-icons/fa';
import { getReceiptData } from '../utils/bookingReceipt';
import './ReceiptPreviewModal.css';

const formatDate = (d) => {
  if (!d) return '-';
  const date = new Date(d);
  return date.toLocaleDateString('en-IN', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
};

const formatCurrency = (amount, currency = 'INR') => {
  if (amount == null) return '-';
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency }).format(amount);
};

const formatTime = (d) => {
  if (!d) return '-';
  return new Date(d).toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

const ReceiptPreviewModal = ({ booking, onClose, onDownload }) => {
  const b = getReceiptData(booking);
  if (!b) return null;

  return (
    <div className="receipt-modal-overlay" onClick={onClose}>
      <div className="receipt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="receipt-modal-header">
          <h2 className="receipt-modal-title">Booking Receipt</h2>
          <button className="receipt-modal-close" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </div>

        <div className="receipt-modal-body">
          <div className="receipt-content">
            <p className="receipt-generated">Generated: {formatDate(new Date())}</p>
            <div className="receipt-divider" />

            <div className="receipt-row receipt-row--header">
              <span className="receipt-label">Booking ID</span>
              <span className="receipt-value">#{b.bookingId}</span>
            </div>
            <div className="receipt-row receipt-row--header">
              <span className="receipt-label">Status</span>
              <span className={`receipt-status receipt-status--${b.status}`}>{b.status}</span>
            </div>

            <div className="receipt-section">
              <h3 className="receipt-section-title">Property</h3>
              <p className="receipt-property-name">{b.propertyName}</p>
              <p className="receipt-property-location">{b.propertyCity}{b.propertyCity && b.propertyState ? ', ' : ''}{b.propertyState}</p>
            </div>

            {b.bookingType === 'meeting' ? (
              <div className="receipt-section">
                <h3 className="receipt-section-title">Meeting Details</h3>
                <p className="receipt-date">Date: {formatDate(b.checkIn)}</p>
                <p className="receipt-meta">Time: {formatTime(b.checkIn)} – {formatTime(b.checkOut)}</p>
                <p className="receipt-meta">Duration: {b.durationLabel || '-'}</p>
                <p className="receipt-meta">Attendees: {b.guests}</p>
                {b.purpose && <p className="receipt-meta">Purpose: {b.purpose}</p>}
              </div>
            ) : (
              <div className="receipt-dates-grid">
                <div className="receipt-dates-col">
                  <h3 className="receipt-section-title">Check-in</h3>
                  <p className="receipt-date">{formatDate(b.checkIn)}</p>
                  <p className="receipt-meta">Nights: {b.nights}</p>
                </div>
                <div className="receipt-dates-col">
                  <h3 className="receipt-section-title">Check-out</h3>
                  <p className="receipt-date">{formatDate(b.checkOut)}</p>
                  <p className="receipt-meta">Guests: {b.guests}</p>
                </div>
              </div>
            )}

            <div className="receipt-section">
              <h3 className="receipt-section-title">Guest</h3>
              <p className="receipt-guest-name">{b.guestName}</p>
              {b.guestEmail && <p className="receipt-guest-detail">{b.guestEmail}</p>}
              {b.guestPhone && <p className="receipt-guest-detail">{b.guestPhone}</p>}
            </div>

            <div className="receipt-divider" />
            <div className="receipt-total-row">
              <span className="receipt-total-label">Total Amount</span>
              <span className="receipt-total-value">{formatCurrency(b.totalPrice, b.currency)}</span>
            </div>
            <div className="receipt-payment-method">
              <span className="receipt-label">Payment</span>
              <span className="receipt-value">{b.paymentLabel || (b.paymentMethod === 'online' && b.paymentStatus === 'paid' ? 'Paid online' : 'Pay at hotel at check-in')}</span>
            </div>
            <p className="receipt-footer">Thank you for booking with us. For support, contact the host or property.</p>
          </div>
        </div>

        <div className="receipt-modal-footer">
          <button className="receipt-btn receipt-btn--secondary" onClick={onClose}>
            Close
          </button>
          <button className="receipt-btn receipt-btn--primary" onClick={() => { onDownload(booking); onClose(); }}>
            <FaDownload /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReceiptPreviewModal;
